import { useTranslation } from 'react-i18next'

import { AlertBox } from 'components/Box'
import { RelatedSettingsProps } from './types'

export const RelatedSettings = ({ children, title, url }: RelatedSettingsProps): JSX.Element => {
  const { t } = useTranslation('components')

  return (
    <AlertBox
      severity='info'
      sx={{ height: 'fit-content' }}
      title={title ?? t('relatedSettings')}
      url={url}
    >
      {children}
    </AlertBox>
  )
}
